import React, { createContext, useContext, useState } from 'react';

const AnimationContext = createContext();

export const useAnimationContext = () => useContext(AnimationContext);

export const AnimationProvider = ({ children }) => {
  const [isPreloaderComplete, setIsPreloaderComplete] = useState(false);

  return (
    <AnimationContext.Provider value={{ isPreloaderComplete, setIsPreloaderComplete }}>
      {children}
    </AnimationContext.Provider>
  );
};